
















import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {LatLon} from "../../n-maps/models/LatLon";
import {equals} from "../../utils";
import schemaHelper from "../../kepler_sdk/schemaHelper";

@Component({
  components: {},
})
export default class LatLng extends Vue {
  // Value passed by v-model
  @Prop() public readonly value: any

  @Prop({default: ''}) public readonly placeholder!: string
  @Prop({default: ''}) public readonly label!: string

  public markerPosition: LatLon = new LatLon(39,9)
  public centerMap: LatLon = this.markerPosition


  @Watch('value')
  public valueChanged(newValue: any, oldValue: any) {
  if(!newValue) {
    this.markerPosition = new LatLon(39,9)
    return
  }
    if (!equals(newValue, oldValue)) {
      this.markerPosition = new LatLon(newValue.latitude, newValue.longitude)
      this.centerMap = this.markerPosition
    }
  }

  mounted() {
    this.valueChanged(this.value, null)

  }

  public creckers(e: LatLon) {
    console.log(e, this)
    this.markerPosition = e
    this.$emit('input', e)
  }
}
